import styled from 'styled-components';
import { ActionPanel } from 'components/molecules/action-panel';

export const Popover = styled(ActionPanel.Popover).attrs({
  id: 'date_wrapper',
})`
  height: 382px;
  width: 276px;

  .ant-picker {
    width: 244px;
    margin: 0 var(--popover-spacing) var(--popover-spacing);
  }
`;

export const DatePopoverAction = styled(ActionPanel.PopoverAction)``;
